export type TTeamMemberSortField = 'name' | 'createdAt';

type TSortableMember = { User: { name: string; lastname: string; createdAt: string } };

const fullName = ({ User }: TSortableMember) => [User.name, User.lastname].filter(Boolean).join(' ');

const timestamp = ({ User }: TSortableMember) => {
  const parsed = Date.parse(User.createdAt);

  return Number.isNaN(parsed) ? 0 : parsed;
};

const compare = (field: TTeamMemberSortField, a: TSortableMember, b: TSortableMember) =>
  field === 'name'
    ? fullName(a).localeCompare(fullName(b), undefined, { sensitivity: 'base' })
    : timestamp(a) - timestamp(b);

export const sortTeamMembers = <T extends TSortableMember>(
  members: readonly T[],
  field: TTeamMemberSortField | '',
  reverse: boolean,
): T[] =>
  field === '' ? [...members] : [...members].sort((a, b) => (reverse ? compare(field, b, a) : compare(field, a, b)));
